export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-14.34fc7435.jpg";